var Floors = {
	initialized: false,
	defalutFloor:null,
	all:[],

	init: function() {
		if (!Floors.initialized) {
			ssi("Plan","getPlans",{"folder":player.folder},function(resp) {
				Floors.all = resp.data;
				for(var n in Floors.all) {
					Floors.all[n].nobasement = true;
					Floors.all[n].position = parseInt(n) + 1;
					for(var l in Floors.all[n].levels) {
						if (Floors.all[n].levels[l].level == -1) Floors.all[n].nobasement = false;
						if (Floors.all[n].levels[l].default == "1" && Floors.defalutFloor == null) {
							Floors.defaultFloor = Floors.all[n].levels[l].plan_id;
						}
					}
				}
			});

			Floors.node = $("<div id='floors'></div>");
			$("#panels").append(Floors.node);

			Floors.initialized = true;
		}
	},

	findFloor: function(id) {
		for(var n in Floors.all) {
			Floors.all[n].nobasement = true;
			Floors.all[n].position = parseInt(n) + 1;
			for(var l in Floors.all[n].levels) {
				if (id == Floors.all[n].levels[l].plan_id) {
					return Floors.all[n];
				}
			}
		}
	},

	open: function() {
		if (!Floors.initialized) {
			Floors.initialized = true;
		}

		Floors.node.html(TPL.render("floors-main", {}));

		$("#floors").show();
		$("#floors_result_box").html("");

		ssi("Plan","getPlans",{"folder":player.folder},function(resp) {
			$("#floors_result_box").append(TPL.render("floor-header", {}));
			for(var n in resp.data) {
				resp.data[n].nobasement = true;
				resp.data[n].position = parseInt(n) + 1;
				for(var l in resp.data[n].levels) {
					if (Plan.planData.plan_id == resp.data[n].levels[l].plan_id) resp.data[n].levels[l].active = true; else resp.data[n].levels[l].active = false;
					if (resp.data[n].levels[l].level == -1) resp.data[n].nobasement = false;
				}
				resp.data[n].pdown = "on" + Events.pointer.down;

				$("#floors_result_box").append(TPL.render("floor-row", resp.data[n]));
			}
		});
	},

	selectFloors: function(exit) {
		ssi("Plan","getPlans",{"folder":player.folder},function(resp) {
			var current = null;

			for(var n in resp.data) {
				for(var l in resp.data[n].levels) {
					if (resp.data[n].levels[l].plan_id == exit) {
						current = resp.data[n];
						break;
					}
				}
			}

			current.pdown = "on" + Events.pointer.down;
			Dialog.message("<img src='/html5/assets/floors.png'>", TPL.render("select-floor", current), TPL.lng("plan.cancel", "Anuluj"), function() {

			});
		});

		//Dialog.select("<img src='/html5/assets/floors.png'>", placeName + Plan.landmarks[no2].place.place_id, "", ["Przejdź tutaj", "Wyznacz trasę"], function(no) {
		//});
	},

	load: function(plan) {
		Floors.close();
		Plan.load(plan);
	},

	close: function() {
		$("#floors").hide();
		Dialog.closeDialogs();
	}

}